import { render, staticRenderFns } from "./ContextMenuClickNotClose.vue?vue&type=template&id=3bec8143"
import script from "./ContextMenuClickNotClose.vue?vue&type=script&lang=js"
export * from "./ContextMenuClickNotClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports